import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  notices: [],
  recurrency: [],
  notice: {},
  loading: false,
  formLoading: false,
  exportLoading: false,
  exportSuccess: false,
  error: false,
  recurrencyError: false,
  success: false,
  paging: false,
  sendMail: false,
  coownersFields: false,
  coownerUser: false,
  sendMailSuccess: false,
  sendNoticeToUser: {},
  noticeCreated: 0,
  getNoticePlaceholder: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Notices/index.js